import { createFileRoute } from '@tanstack/react-router'
import LoginPage from '@features/auth/components/LoginPage'

export const Route = createFileRoute('/register')({
  component: RegisterPage,
})

function RegisterPage() {
  return <LoginPage mode="signup" />
}
